import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 lg:py-32 bg-emerald-dark text-white relative overflow-hidden" data-id="element-44">
      <div className="absolute inset-0 opacity-[0.04]" style={{
      backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-45" />

      <div className="max-w-3xl mx-auto px-5 sm:px-8 relative z-10 text-center" data-id="element-46">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-47">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-cream mb-8 leading-tight" data-id="element-48">
            Cada Noche Sin Acción Es Una Noche Más de Dolor
          </h2>

          <p className="text-xl sm:text-2xl font-body text-emerald-light/90 mb-10 leading-relaxed" data-id="element-49">
            La neuropatía intenta quitarte tu libertad, pero cada vez que cuidas
            tus pies, estás recuperando un pedazo de tu autonomía.
          </p>

          <blockquote className="text-xl sm:text-2xl font-heading font-medium italic text-gold-brand mb-12 border-l-4 border-gold-brand pl-6 max-w-xl mx-auto text-left" data-id="element-50">
            "No eres una víctima de tu diagnóstico. Eres el guardián de tus
            propios pasos."
          </blockquote>

          <a href="#pricing" className="inline-flex items-center justify-center gap-3 bg-gold-brand hover:bg-yellow-600 text-charcoal font-bold text-xl sm:text-2xl py-5 px-10 rounded-xl shadow-2xl transition-all hover:scale-105" data-id="element-51">
            ¡Quiero Empezar Hoy Mismo!
            <ArrowDownIcon className="w-5 h-5 animate-bounce" data-id="element-52" />
          </a>

          <p className="mt-8 text-lg font-body text-emerald-light/70" data-id="element-53">
            No estás solo en esto. Tu camino hacia el alivio empieza aquí.
          </p>
        </motion.div>
      </div>
    </section>;
}